import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Select, Typography } from "antd";
import { Statuses, Actions } from "../../constant/status";

const { Text } = Typography;
const { Option } = Select;

const StatusFormItemComponent = ({
  t,
  style,
  defaultValue,
  onSelect,
  showDoneOption = false,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  name = "status",
  recordInfo
}) => (
  <Form.Item
    name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
    label={showLabel ? <Text strong={strong}>{t("form.status.label")}</Text> : null}
    style={style}
    colon={false}
    rules={[{ required, message: t("form.status.error_required") }]}
  >
    {editable ? (
      <Select
        defaultValue={Statuses[defaultValue].title(t)}
        placeholder={t("form.status.placeholder")}
        style={style}
        onSelect={onSelect}
      >
        {Object.values(Statuses)
          .filter((status) => !status.key.includes("-free"))
          .map((status, index) => (
            <Option key={index} value={status.key}>
              {status.title(t)}
            </Option>
          ))}
        {showDoneOption && (
          <Option key={Actions.done.key} value={Actions.done.key}>
            {Actions.done.title(t)}
          </Option>
        )}
      </Select>
    ) : (
      <Text>{Statuses[defaultValue].title(t) ? `${Statuses[defaultValue].title(t)}` : "-"}</Text>
    )}
  </Form.Item>
);

const StatusFormItem = withTranslation()(StatusFormItemComponent);

export { StatusFormItem };
